import React from "react";
import {
  Dialog,
  Spinner,
  Label,
  Input,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Button,
} from "@fluentui/react-components";
import {
  AddressSVG,
  ConnectAccountSVG,
  DrivingLicenceSVG,
  EyeViewDisableSVG,
  EyeViewSVG,
  InsuranceSVG,
  PhoneSVG,
  UserFormAddSVG,
} from "../../static/svgs";
import { useState, useEffect } from "react";
// import { currentUserId } from "../../services/authService";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../services/firebase";
import { Base_Url } from "../../services/firebase";
import { noWrap } from "@fluentui/react";

function EditPasswordDialogBox({
  isDeleteDialogOpen,
  setIsOpen,
  text,
  userid,
}) {
  const [loading, setLoading] = React.useState(false);
  const [user] = useAuthState(auth);
  const [passwordVisible, setPasswordVisible] = useState(true);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleUpdate = async () => {
    setError("");
    if (!password) {
      setError("Password must be at least 6 characters.");
      return;
    }

    setLoading(true);
    try {
      if (!user) {
        setError("User not authenticated.");
        return;
      }

      // Get a valid ID token from Firebase user rather than relying on user.accessToken
      const token = await user.getIdToken();

      const response = await fetch(`${Base_Url}/updateUserPassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Do NOT send Access-Control-Allow-Origin from the client — it's a response header
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify({
          userId: userid,
          newPassword: password,
        }),
      });

      if (!response.ok) {
        const errText = await response.text().catch(() => "");
        console.error("API error:", response.status, errText);
        setError(`API error: ${response.status} ${errText}`);
        return;
      }

      const data = await response.json().catch(() => null);
      setIsOpen(false);
    } catch (error) {
      console.error("Error updating password:", error);
      setError("Failed to update password. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={isDeleteDialogOpen}
      onOpenChange={(e, data) => setIsOpen(data.open)}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Edit {text}</DialogTitle>
          <DialogContent>
            <div style={{ marginBottom: "16px" }}>
              Are you sure you want to update this {text}?
            </div>

            <span style={{marginRight: "8px"}} >
              <Label className={"side-drawer-field__label"} style={{ marginLeft: "4px" }}>Edit Password</Label>
            </span>
            <Input
              placeholder={"Enter Password"}
              contentAfter={
                <span
                  className="pointer"
                  onClick={() => setPasswordVisible((prev) => !prev)}
                  style={{
                    cursor: "pointer",
                    marginLeft: "8px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {passwordVisible ? (
                    <EyeViewSVG aria-label="Show password" />
                  ) : (
                    <EyeViewDisableSVG aria-label="Hide password" />
                  )}
                </span>
              }
              className={
                "side-drawer-field-date  side-drawer-field__gap side-drawer-field__gap"
              }
              onChange={(ev) => setPassword(ev.target.value)}
              type={passwordVisible ? "password" : "text"}
            />
          </DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={handleUpdate}
              style={{
                backgroundColor: "#E97451",
                color: "black",
                whiteSpace: "nowrap",
                position: "relative",
              }}
              disabled={loading || !password}
            >
              {loading ? <Spinner size="tiny" /> : "Update"}
            </Button>
            <Button appearance="secondary" onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default EditPasswordDialogBox;